import React, { useEffect, useState } from 'react';
import { useMediaQuery, useTheme, Paper, Tabs, Tab, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

// Ícones
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import HistoryIcon from '@material-ui/icons/History';

import useApi from '../../../../utils/useApi';
import TransferNew from '../New/transferNew';
import TransferSearch from '../Search/transferSearch';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: theme.palette.background.default,
    overflow: 'hidden',
  },
  header: {
    flexShrink: 0,
    zIndex: 5,
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  content: {
    flexGrow: 1,
    overflow: 'hidden', // O scroll é gerenciado pelos filhos
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  }
}));

const TransferShow = () => {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // 0 = Nova Transferência, 1 = Histórico
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const [usersLoad, usersInfo] = useApi({
    method: 'get',
    url: '/users',
  });

  const [paymentLoad, paymentInfo] = useApi({
    method: 'get',
    url: '/payments/methods',
  });

  const [cashierLoad, cashierInfo] = useApi({
    method: 'get',
    url: '/cash-registers',
    params: { isActive: 1 },
  });

  // Função para forçar a ida ao histórico após criar uma sangria
  const goToHistory = () => setTabValue(1);

  useEffect(() => {
    usersLoad();
    cashierLoad();
    paymentLoad();
  }, []);

  return (
    <div className={classes.root}>
      {/* Navegação por Abas */}
      <Paper square className={classes.header}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          centered
        >
          <Tab icon={<AddCircleOutlineIcon />} label="Nova Sangria" />
          <Tab icon={<HistoryIcon />} label="Histórico" />
        </Tabs>
      </Paper>

      {/* Área de Conteúdo */}
      <div className={classes.content}>
        {tabValue === 0 && (
           <TransferNew
             usersInfo={usersInfo}
             cashierInfo={cashierInfo}
             goToHistory={goToHistory}
             mobile={mobile}
           />
        )}
        {tabValue === 1 && (
           <TransferSearch
             usersInfo={usersInfo}
             paymentInfo={paymentInfo}
             cashierInfo={cashierInfo}
             mobile={mobile}
           />
        )}
      </div>
    </div>
  );
};

export default TransferShow;